export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Instalación/Grupo\",\n    \"label_plural\": \"{{count}} Instalación/Grupo\"\n}\n"